import {Dispatch, SetStateAction, useEffect} from 'react';
import getAds from '@jobseeker/common-core/helpers/loadAds';

import type {
  SectionElementType,
  AdsOptions,
} from '@jobseeker/common-core/types';

const useLoadAds = (
  slotId: string,
  setAds: Dispatch<
    SetStateAction<
      | SectionElementType[]
      | /* eslint-disable @typescript-eslint/no-explicit-any */ any
    >
  >,
  options?: AdsOptions,
  isCourseAds = false,
  loadAds = true,
  setAdsLoaded?: Dispatch<SetStateAction<boolean>>,
  enabled = true
) => {
  useEffect(() => {
    if (!enabled) return;
    const loadAdsApi = async () => {
      const adsInfo = await getAds(
        slotId,
        options,
        isCourseAds,
        false,
      );
      if (adsInfo?.length > 0) {
        setAds(adsInfo);
      }
      setAdsLoaded && setAdsLoaded(true);
    };

    if (loadAds && slotId) {
      loadAdsApi();
    } else {
      setAdsLoaded && setAdsLoaded(true);
    }
  }, [slotId, setAds, loadAds, enabled, options?.logged]);
};

export default useLoadAds;
